import React from "react";

import { Statistics, IconPanel, Grid } from "@tiny/components";
import { formatNumber } from "@tiny/components/src/utils/formatUtils";
import IntegrationsOutline from "@tiny/icons/generated/IntegrationsOutline";
import UploadOutline from "@tiny/icons/generated/UploadOutline";
import { useSegmentsStatistics } from "../../../hooks/useSegmentsStatistics";

function SegmentsStatistics() {
  const { theme, mdUp, lgUp, totalCustom, totalPredefined, isLoading } =
    useSegmentsStatistics();

  return (
    <Grid container spacing={lgUp ? 5 : mdUp ? 4 : 3}>
      <Grid item xs={12} md={12}>
        <IconPanel
          icon={<IntegrationsOutline />}
          color={theme.palette.purple.dark}
          hasBorderRadius={mdUp}
        >
          <Statistics
            valueVariant="h2"
            value={isLoading ? "-" : formatNumber(totalCustom) || undefined}
            title="Custom segments"
            info="Build your own segments with custom filters"
          />
        </IconPanel>
      </Grid>
      <Grid item xs={12} md={6} style={{ display: "none" }}>
        <IconPanel
          icon={<UploadOutline />}
          color={theme.palette.blue.dark}
          hasBorderRadius={mdUp}
        >
          <Statistics
            valueVariant="h2"
            value={isLoading ? "-" : formatNumber(totalPredefined) || undefined}
            title="Predefined segments"
            info="Our most popular segments pre-built for you"
          />
        </IconPanel>
      </Grid>
    </Grid>
  );
}

export default SegmentsStatistics;
